// @flow
import * as React from 'react'

import './ColoredText.scss'

export type Color = 'gray' | 'yellow' | 'blue' | 'green' | 'orange' | 'red' | 'white' | 'charcoal'

type Props = {
  color: Color,
  children: React.Node,
}

export default class ColoredText extends React.Component<Props> {
  render = () => {
    return <span className={this.className}>{this.props.children}</span>
  }

  get className(): string {
    return ['ColoredText', getModiferClassName(this.props.color)].join(' ')
  }
}

function getModiferClassName(color: Color) {
  switch (color) {
    case 'charcoal':
      return 'ColoredText--charcoal'

    case 'gray':
      return 'ColoredText--gray'

    case 'green':
      return 'ColoredText--green'

    case 'yellow':
      return 'ColoredText--yellow'

    case 'blue':
      return 'ColoredText--blue'

    case 'orange':
      return 'ColoredText--orange'

    case 'red':
      return 'ColoredText--red'

    case 'white':
      return 'ColoredText--white'

    default:
      return ''
  }
}
